import { createSlice } from '@reduxjs/toolkit';

// DOMAIN
import { Domain } from 'constant';

// MODEL
import { AppState } from 'model';

// REDUCER ACTION
import {
  changeAppLoading,
  setAppMessage,
  setAssociationCreated,
  setValidatingAssociation,
  setAppConfiguration,
  setOpenModalToRefreshApp,
  setOnboardingRequired,
  setAppBootstrapToken
} from './reducers';

export const initialState: AppState = {
  associationCreated: false,
  validatingAssociation: true,
  loading: false,
  message: undefined,
  appConfiguration: {
    versionNumber: '0.0.0',
    disabledLovedOne: true
  },
  openModalToRefreshApp: false,
  onboardingRequired: undefined,
  bootstrapToken: undefined
};

export const appSlice = createSlice({
  name: Domain.App,
  initialState,
  reducers: {
    changeAppLoading,
    setAppMessage,
    setAssociationCreated,
    setValidatingAssociation,
    setAppConfiguration,
    setOpenModalToRefreshApp,
    setOnboardingRequired,
    setAppBootstrapToken
  }
});

export default appSlice.reducer;
